import { call, put, select, takeLatest } from 'redux-saga/effects';

import {
  LOADING_DATA_START,
  LOADING_DATA_FINISHED,
} from '../reducers/loading.reducer';

import { handleError } from './helper';
import { extensionApi, folderApi } from '../services';
import {
  EXTENSIONS_DELETE_EXTENSION,
  EXTENSIONS_DELETE_EXTENSION_FAILURE,
  EXTENSIONS_DELETE_EXTENSION_SUCCESS,
  EXTENSIONS_FETCH,
  EXTENSIONS_FETCH_FAILURE,
  EXTENSIONS_FETCH_SUCCESS,
  EXTENSIONS_SEARCH,
  EXTENSIONS_SEARCH_FAILURE,
  EXTENSIONS_SEARCH_SUCCESS,
  EXTENSIONS_FETCH_TAGS,
  EXTENSIONS_FETCH_TAGS_SUCCESS,
  EXTENSIONS_FETCH_TAGS_FAILURE,
  EXTENSIONS_TOGGLE_TAG,
  EXTENSIONS_TOGGLE_TAGS,
  EXTENSIONS_NAME_SEARCH,
  EXTENSIONS_NAME_SEARCH_SUCCESS,
  EXTENSIONS_NAME_SEARCH_FAILURE,
  EXTENSIONS_MOVE_FILE,
  extensionMoveFileSuccess,
  fetchExtensionsByQuery,
} from '../reducers/extensions.reducer';
import { showNotification } from '../helpers/notification';
import * as folderActions from '../reducers/folder.reducer';
import * as extensionsActions from '../reducers/extensions.reducer';

function* fetchExtensionsRequest() {
  try {
    yield put({ type: LOADING_DATA_START });
    const folderId = yield select(getCurrentDirectory);
    const result = yield call(extensionApi.fetchExtensions, { folderId });
    yield put({
      type: EXTENSIONS_FETCH_SUCCESS,
      payload: result.data.extensions,
    });
  } catch (error) {
    const message = yield* handleError(error);
    yield put({ type: EXTENSIONS_FETCH_FAILURE, payload: message });
  }
  yield put({ type: LOADING_DATA_FINISHED });
}

function* deleteExtensionRequest({ payload: { id } }) {
  try {
    yield put({ type: LOADING_DATA_START });
    yield call(extensionApi.deleteExtension, { id });
    yield put({ type: EXTENSIONS_DELETE_EXTENSION_SUCCESS, payload: { id } });
    yield put(folderActions.fetchFolders());
  } catch (error) {
    const message = yield* handleError(error);
    yield put({ type: EXTENSIONS_DELETE_EXTENSION_FAILURE, payload: message });
  }
  yield put({ type: LOADING_DATA_FINISHED });
}

function* searchExtensionsRequest({ payload: { type, name, tags } }) {
  try {
    yield put({ type: LOADING_DATA_START });
    const result = yield call(extensionApi.fetchExtensionsList, {
      type,
      name,
      tags,
    });
    yield put({ type: EXTENSIONS_SEARCH_SUCCESS, payload: result.data });
  } catch (error) {
    const message = yield* handleError(error);
    yield put({ type: EXTENSIONS_SEARCH_FAILURE, payload: message });
  }
  yield put({ type: LOADING_DATA_FINISHED });
}

function* searchExtensionsByNameRequest({ payload: { query, type } }) {
  try {
    yield put({ type: LOADING_DATA_START });
    const result = yield call(extensionApi.fetchExtensionsListByName, {
      query,
      type,
    });
    yield put({ type: EXTENSIONS_NAME_SEARCH_SUCCESS, payload: result.data });
  } catch (error) {
    console.log('error', error);

    const message = yield* handleError(error);
    yield put({ type: EXTENSIONS_NAME_SEARCH_FAILURE, payload: message });
  }
  yield put({ type: LOADING_DATA_FINISHED });
}

function* fetchExtensionsTagsRequest({ payload: { query, type } }) {
  try {
    yield put({ type: LOADING_DATA_START });
    const result = yield call(extensionApi.fetchExtensionsTagsList, {
      query,
      type,
    });
    yield put({ type: EXTENSIONS_FETCH_TAGS_SUCCESS, payload: result.data });
  } catch (error) {
    const message = yield* handleError(error);
    yield put({ type: EXTENSIONS_FETCH_TAGS_FAILURE, payload: message });
  }
  yield put({ type: LOADING_DATA_FINISHED });
}

export function* toggleExtensionsTagRequest({ payload: { tag, type } }) {
  try {
    yield put({ type: LOADING_DATA_START });
    yield put({ type: EXTENSIONS_TOGGLE_TAGS, payload: { tag } });

    const tags = yield select(getCurrentTags);

    let data;
    if (tags.length) {
      data = yield call(extensionApi.fetchExtensionsRelatedTagsList, {
        tags,
        type,
      });
      yield put(fetchExtensionsByQuery(type, null, tags));
    } else {
      data = yield call(extensionApi.fetchExtensionsTagsList, { type });
      yield put(extensionsActions.fetchExtensions());
    }

    yield put({ type: EXTENSIONS_FETCH_TAGS_SUCCESS, payload: data.data });
  } catch (error) {
    const message = yield* handleError(error);
    yield put({ type: EXTENSIONS_FETCH_TAGS_FAILURE, payload: message });
  }
  yield put({ type: LOADING_DATA_FINISHED });
}

export function* moveExtensionFileRequest({ payload: { folderId, fileId } }) {
  try {
    yield call(folderApi.moveFile(folderId, fileId));
    yield put(extensionMoveFileSuccess(fileId));
  } catch (error) {
    const message = yield* handleError(error, 'File move failed.');
    showNotification(message);
  }
}

export function* fetchExtensions() {
  yield takeLatest(EXTENSIONS_FETCH, fetchExtensionsRequest);
}

export function* deleteExtension() {
  yield takeLatest(EXTENSIONS_DELETE_EXTENSION, deleteExtensionRequest);
}

export function* searchExtensions() {
  yield takeLatest(EXTENSIONS_SEARCH, searchExtensionsRequest);
}

export function* searchExtensionsByName() {
  yield takeLatest(EXTENSIONS_NAME_SEARCH, searchExtensionsByNameRequest);
}

export function* fetchExtensionsTags() {
  yield takeLatest(EXTENSIONS_FETCH_TAGS, fetchExtensionsTagsRequest);
}

export function* toggleExtensionsTag() {
  yield takeLatest(EXTENSIONS_TOGGLE_TAG, toggleExtensionsTagRequest);
}

export function* moveExtensionFile() {
  yield takeLatest(EXTENSIONS_MOVE_FILE, moveExtensionFileRequest);
}

const getCurrentDirectory = state => state.folder.currentDirectory;
const getCurrentTags = state => state.extensions.currentTags;



// WEBPACK FOOTER //
// ./src/sagas/extensions.saga.js